import React from "react";
import { Grid, Paper, Button, Typography } from "@material-ui/core";
import { LocalizationContext } from "../../../core/localization/Localization";
import { WeeklyTradingReportFilter } from "../../../data/reports/weeklyTrade/types";
import { useAuth } from "../../../data/auth/hooks";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { StringInput } from "../../components/common/StringInput";

export enum WTRFilterEditorType {
  Basic,
  Extended,
}

interface WTRFilterEditorProps {
  filter: WeeklyTradingReportFilter;
  editFilter: (prop: keyof WeeklyTradingReportFilter, value: any) => void;
  save: (numofweeks: number) => void;
  reset: () => void;
  type: WTRFilterEditorType;
}

export const WTRFilterEditor: React.FunctionComponent<WTRFilterEditorProps> = ({
  filter,
  editFilter,
  save,
  type,
  reset,
}) => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const { getString } = React.useContext(LocalizationContext);
  const [auth] = useAuth();

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      editFilter(event.target.name as any, Number(event.target.value));
    },
    [editFilter]
  );

  return (
    <Paper
      style={{
        paddingLeft: "70px",
        paddingRight: "70px",
        paddingTop: "15px",
        paddingBottom: "15px",
      }}
    >
      <Grid container direction="column" spacing={6}>
        <Grid item container direction="row" spacing={2}>
          <StringInput<WeeklyTradingReportFilter>
            type="number"
            property="numofweeks"
            item={filter}
            onChange={handleChange}
            label={getString("weeklyNumofWeeks")}
          />
        </Grid>

        <Grid item container direction="row-reverse" spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                if (filter.numofweeks) {
                  save(filter.numofweeks);
                }
                showWithDrawer(undefined);
              }}
            >
              {getString("orderFilterConfirm")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};
